import * as Yup from "yup";
import { Strings } from "@app/constants";

export const addModelSchema = Yup.object()
  .shape({
    brandId: Yup.string().required(
      Strings.validation.selectionRequired("Brand")
    ),

    name: Yup.string()
      .required(Strings.validation.fieldRequired("Car Model Name"))
      .min(2, "Model name must be at least 2 characters")
      .max(50, "Model name must not exceed 50 characters"),

    fuelType: Yup.string().required(
      Strings.validation.selectionRequired("Fuel Type")
    ),

    variants: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string()
            .required("Variant name is required")
            .min(1, "Variant name cannot be empty"),
        })
      )
      .min(1, "At least one variant is required"),

    image: Yup.mixed<File>()
      .nullable()
      .test("fileType", "Only image files are allowed", (value) => {
        if (!value) return true; // optional image
        return ["image/jpeg", "image/png", "image/webp"].includes(value.type);
      })
      .test("fileSize", "Image size must be less than 5MB", (value) => {
        if (!value) return true;
        return value.size <= 5 * 1024 * 1024;
      }),
  })
  .required();
